import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { fromEvent, pairwise, switchMap, takeUntil } from 'rxjs';
import { SharedHttpService } from '../../services/shared-http.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  @ViewChild('canvas') public canvas: ElementRef;
  private cx: CanvasRenderingContext2D;
  userIdEncrypt;
  userId;
  userName:string;
  displayName:string;
  email:string;
  mobile:string;
  telephoneNo:string;
  isActive:boolean=false;
  loading:boolean=false;
  signatureSrc:any;

  constructor( public sharedService: SharedHttpService,
    private route:ActivatedRoute
  ) { }

  ngAfterViewInit(): void {
    const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
    this.cx = canvasEl.getContext('2d');
    canvasEl.height = 50;
    canvasEl.width = 200;
    this.cx.lineWidth = 1;
    this.cx.lineCap = 'round';
    this.cx.strokeStyle = "#5100ff";
    this.captureEvents(canvasEl);
  }

  clearsrow() {
    this.cx.clearRect(0, 0, 250, 150);
  }

  ngOnInit(): void {
    this.loading=true;
    this.userIdEncrypt=this.route.snapshot.params['userIdEncrypt'];
    let url=`api/User/GetUserDetails?UserIdEncrypt=${this.userIdEncrypt}`
  
    this.sharedService.get(url).subscribe((res) => {
      this.userId=res.userId
      this.userName= res.username;
      this.isActive = res.isActive;
      this.displayName = res.fullName;
      this.email = res.email;
      this.telephoneNo= res.phoneNumber;
      this.mobile=res.mobile;
      this.sharedService.getString(`api/User/GetSignature`).subscribe(res=>{
        this.signatureSrc = `data:image/png;base64,${res}`;
      })
      this.loading=false;
    });
  }

  private drawOnCanvas( prevPos: { x: number, y: number }, currentPos: { x: number, y: number } ) {
    if (!this.cx) { return; }
      this.cx.beginPath();
    if (prevPos) {
      this.cx.moveTo(prevPos.x, prevPos.y);
      this.cx.lineTo(currentPos.x, currentPos.y);
      this.cx.stroke();
    }
  }
  private captureEvents(canvasEl: HTMLCanvasElement) {
    fromEvent(canvasEl, 'mousedown').pipe(switchMap((e) => {
      return fromEvent(canvasEl, 'mousemove').pipe(
        takeUntil(fromEvent(canvasEl, 'mouseup')),
        takeUntil(fromEvent(canvasEl, 'mouseleave')),
        pairwise()
      )
    })).subscribe((res: [MouseEvent, MouseEvent]) => {
      const rect = canvasEl.getBoundingClientRect();
      const prevPos = {
          x: res[0].clientX - rect.left,
          y: res[0].clientY - rect.top
      };
      const currentPos = {
          x: res[1].clientX - rect.left,
          y: res[1].clientY - rect.top
      };
      this.drawOnCanvas(prevPos, currentPos);
    });
    fromEvent(canvasEl, 'touchstart').pipe(switchMap((e) => {
      return fromEvent(canvasEl, 'touchmove').pipe(
        takeUntil(fromEvent(canvasEl, 'touchend')),
        takeUntil(fromEvent(canvasEl, 'touchcancel')),
        pairwise()
      )
    })).subscribe((res: any) => {
      const rect = canvasEl.getBoundingClientRect();
      const prevPos = {
          x: res[0].touches[0].pageX - rect.left,
          y: res[0].touches[0].pageY - rect.top
      };
      const currentPos = {
          x: res[1].touches[0].pageX - rect.left,
          y: res[1].touches[0].pageY - rect.top
      };
      this.drawOnCanvas(prevPos, currentPos);
    });
  }

  numberOnly(event) {
    var inp = String.fromCharCode(event.keyCode);
    let pattern =/^\d+$/;
    if (pattern.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  } 

  onEdit() {
    let url = `api/User/Update`;
    let user = {
      "userIdEncrypt": this.userIdEncrypt,
      "userId": this.userId,
      "username": this.userName,
      "email": this.email,
      "mobile": this.mobile,
      "displayName":this.displayName,
      "telephoneNo":this.telephoneNo ,
      "isActive": this.isActive,
    }
    this.sharedService.put(url,[user]).subscribe((res) => {
      this.sharedService.showSuccessKey('UserEditedSuccessfully')
    });
  }

  signatureSelected( file: any) {
    let formData: FormData = new FormData();
    formData.append('file', file.target.files[0]);
    formData.append('FileName', file.target.files[0].name);
    formData.append('ContentType', file.target.files[0].type);

    if (file.target.files[0].name.endsWith("png") || file.target.files[0].name.endsWith("jpg")) {
      this.sharedService.post(`api/User/SaveSignature`, formData).subscribe(res => {
        if (res) {
          this.sharedService.getString(`api/User/GetSignature`).subscribe(res => {
            this.signatureSrc = `data:image/png;base64,${res}`;
          })
          this.sharedService.showSuccessKey('SuccessfullySaved');
        } else {
            this.sharedService.showSuccessKey("ErrorPleaseTryAgain");
        }
      });
    }else {
      this.sharedService.showErrorKey("برجاء رفع ملف من نوع صورة png - jpg");
    }
  }
  savesign() {
    let canva = document.getElementById("canvasSignature") as HTMLCanvasElement;
    let image1 = canva.toDataURL("image/png");
    this.sharedService.post(`api/User/SaveSignature2`, { image: image1 }).subscribe(res => {
      if (res) {
        this.sharedService.getString(`api/User/GetSignature`).subscribe(res => {
          this.signatureSrc = `data:image/png;base64,${res}`;
        })
        this.sharedService.showSuccessKey('SuccessfullySaved');  
      } else {
        this.sharedService.showErrorKey("ErrorPleaseTryAgain");
      }
    });
  }
}
